import FormikTypeahead, {
  FormikTypeaheadProps,
} from "../../@ui/FormikTypeahead/FormikTypeahead";

interface CountryTypeaheadProps extends FormikTypeaheadProps {}

const CountryTypeahead = ({ ...props }: CountryTypeaheadProps) => {
  const getLabel = (x: any) => {
    return (
      <div className="d-flex gap-2">
        <img src={`https://flagcdn.com/24x18/${x.code?.toLowerCase()}.png`} />
        <div>{x.label}</div>
      </div>
    );
  };

  return <FormikTypeahead renderMenuItemChildren={getLabel} {...props} />;
};

export default CountryTypeahead;
